<div class="close-x">
    <button cdkFocusInitial aria-label="Close dialog" (click)="closeClick()">
        <xm-media-image [staticImagePath]="'close_black.svg'" [imageSource]="'buy_static_base_url'" [staticImageAlt]="'close'" size="width"></xm-media-image>
    </button>
</div>
